import * as PIXI from "pixi.js";
import InfoSlider from "./InfoSlider";
import { rootEventBus, EnumRootEventBus } from "../../managers/RootEventBus";
import { CENTER_ANGLE_COLOR } from "../../types/Config";
import { Dims } from "../../types/Interface";
import addInteractivity from "../../utils/addInteractivity";
import { CustomCursorType } from "../UI/CustomCursor/CustomCursor";


export default class InfoSliderDot extends PIXI.Graphics {
  private InfoSlider: InfoSlider = InfoSlider.getInstance();
  private infoSliderDims: Dims;
  private pNumber: number;
  private currentPage = false;

  constructor(pNumber: number, x: number, infoSliderDims: Dims) {
    super();
    this.pNumber = pNumber;
    this.currentPage = !pNumber;
    this.infoSliderDims = infoSliderDims;

    this.generate();
    this.addCoord(x);
    this.addToCon();

    const handleDownFunc = () => this.setInfoSliderPage();
    addInteractivity(
      this,
      { handleDownFunc },
      CustomCursorType.pointer,
      undefined,
      true
    );

    rootEventBus.on(EnumRootEventBus.setCurPage, cPage => this.setCurPage(Number(cPage)));
  }
  private addToCon = () => this.InfoSlider.addChild(this);
  private setInfoSliderPage = () => rootEventBus.emit(EnumRootEventBus.setInfoSliderPage, this.pNumber);
  private setCurPage(curPage: number) {
    this.currentPage = curPage == this.pNumber ? true : false;
    this.generate()
  }

  private addCoord(x: number) {
    this.x = x;
    this.y = this.infoSliderDims.height / 2 + 25;
  }
  private generate() {
    const dotColor = CENTER_ANGLE_COLOR;
    const cs = {
      fill: this.currentPage ? dotColor.color : 0xFFFFFF,
      color: !this.currentPage ? dotColor.textColor : dotColor.color
    }
    this.clear()
      .circle(0, 0, 10)
      .fill(cs.fill)
      .stroke({ width: 2, color: cs.color })
  }
}